import React, {useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import mediaPlaceholder from '../../../assets/img/media_img.webp';
import mediaStyles from '../MediaAndNews.module.css';
import s from './MediaImageCarousel.module.css';
import {BannerImagesType} from '../../../types/TypesNews';

interface MediaImageCarouselProps {
	banners?: BannerImagesType[];
}

const FALLBACK_BANNERS: BannerImagesType[] = [
	{img_link: mediaPlaceholder, news_id: 0},
	{img_link: mediaPlaceholder, news_id: 0},
	{img_link: mediaPlaceholder, news_id: 0},
];

const MediaImageCarousel: React.FC<MediaImageCarouselProps> = ({banners}) => {
	const navigate = useNavigate();

	const slides = useMemo(
		() => (banners && banners.length > 0 ? banners : FALLBACK_BANNERS),
		[banners],
	);

	const [currentIndex, setCurrentIndex] = useState(0);

	const handlePrev = () => {
		setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
	};

	const handleNext = () => {
		setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
	};

	const handleBannerClick = () => {
		const currentSlide = slides[currentIndex];
		if (currentSlide?.news_id) {
			navigate(`/news/${currentSlide.news_id}`);
		}
	};

	const currentSlide = slides[currentIndex];
	const canNavigate = Boolean(currentSlide?.news_id);

	return (
		<div className={`media-img__wrapper ${mediaStyles.imageContainer}`}>
			<div className={s.carousel}>
				<button
					type="button"
					className={s.imageButton}
					onClick={handleBannerClick}
					disabled={!canNavigate}
				>
					<div className={s.imageWrapper}>
						<img
							src={currentSlide?.img_link ?? mediaPlaceholder}
							alt={`media-${currentIndex + 1}`}
							className={s.image}
						/>
					</div>
				</button>
				<button
					type="button"
					className={`${s.navButton} ${s.prevButton}`}
					onClick={handlePrev}
					aria-label="Previous image"
				>
					<span className={s.navIcon} />
				</button>
				<button
					type="button"
					className={`${s.navButton} ${s.nextButton}`}
					onClick={handleNext}
					aria-label="Next image"
				>
					<span className={s.navIcon} />
				</button>
				<div className={s.dots}>
					{slides.map((_, idx) => (
						<button
							type="button"
							key={`media-dot-${idx}`}
							className={`${s.dot} ${idx === currentIndex ? s.activeDot : ''}`}
							onClick={() => setCurrentIndex(idx)}
							aria-label={`Go to image ${idx + 1}`}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default MediaImageCarousel;
